import React, { useState, useEffect } from "react";
import { Spin, Empty } from "antd";
import Archive from "../../components/Archive";
import { archivePosts } from "../../api/mockData";

export default function ArchivePage() {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadArchiveData = async () => {
      try {
        setLoading(true);
        const data = await archivePosts();
        setGroups(data || []);
      } catch (err) {
        console.error('Error loading archive data:', err);
        setError(err.message);
        setGroups([]);
      } finally {
        setLoading(false);
      }
    };

    loadArchiveData();
  }, []);

  if (loading) {
    return (
      <div style={{ 
        width: "100%", 
        padding: "20px",
        maxWidth: "1200px",
        minWidth: "800px",
        margin: "0 auto",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "200px"
      }}>
        <Spin size="large" />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ 
        width: "100%", 
        padding: "20px",
        maxWidth: "1200px",
        minWidth: "800px",
        margin: "0 auto"
      }}>
        <div className="card-glow" style={{ padding: 24 }}>
          <Empty description={`加载失败: ${error}`} />
        </div>
      </div>
    );
  }

  return (
    <div 
      id="archive-page" // 添加ID属性
      style={{ 
        width: "100%", 
        padding: "20px",
        maxWidth: "1200px",
        minWidth: "800px",
        margin: "0 auto"
      }}
    >
      <Archive groups={groups} />
    </div>
  );
}